import { Editor } from '@lumapps/wrex/slate';

import { isSelectionInColumn } from './isSelectionInColumn';

export const isColumnsAllowed = (editor: Editor) => (): boolean => {
    const isInColumn = isSelectionInColumn(editor);

    return !isInColumn;
};
